<template>
  <div
    v-intersect
    class="filter-range-input"
    @intersect:enter="onShow"
  >
    <!-- RANGE INPUTS -->
    <BaseForm class="filter-range-input__fields-box" @submit="onChange">
      <BaseInput
        v-model="inputMin"
        :placeholder="$t('catalog.filters.price_from')"
        type="number"
        :disabled="hasRange"
        @change="handleChange"
      />
      <span class="filter-range-input__mdash">&nbsp;&nbsp;</span>
      <BaseInput
        v-model="inputMax"
        :placeholder="$t('catalog.filters.price_to')"
        type="number"
        :disabled="hasRange"
        @change="handleChange"
      />
      <BaseButton
        class="filter-range-input__button"
        type="submit"
        min-width="auto"
        size="small"
        outline
      >
        {{ $t('common.ok') }}
      </BaseButton>
    </BaseForm>
  </div>
</template>

<script setup lang="ts">
import type { CatalogFilter, FilterItemChangePayload } from '~/types/catalog'

type Props = {
  filter: CatalogFilter
  selected: string
}
type Emits = {
  (e: 'on-change' | 'on-show', value: FilterItemChangePayload): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const {
  inputMin,
  inputMax,
  rangeMin,
  rangeMax,
  hasRange
} = useRangeFilter(props)

const handleChange = () => {
  rangeMin.value = inputMin.value
  rangeMax.value = inputMax.value
}

const onChange = () => {
  emit('on-change', {
    filter_code: props.filter.code,
    filter_name: props.filter.name,
    value: `${rangeMin.value}-${rangeMax.value}`,
    isOne: true
  })
}

const onShow = () => {
  emit('on-show', {
    filter_code: props.filter.code,
    filter_name: props.filter.name,
    isOne: true
  })
}

watch(() => props.filter, (filter: CatalogFilter) => {
  if (props.selected) {
    if (filter.min > rangeMin.value) {
      rangeMin.value = filter.min
    }
    if (filter.max < rangeMax.value) {
      rangeMax.value = filter.max
    }
  } else {
    rangeMin.value = filter.min
    rangeMax.value = filter.max
  }
})
</script>

<style lang="scss" scoped>
.filter-range-input {
  flex-direction: column;
  align-items: flex-start;

  &__mdash {
    padding: 0 0.4rem;
    font-size: $h6-font-size;
  }

  &__button {
    display: inline-block;
    margin-left: 1.2rem;
  }

  &__fields-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  @media only screen and (max-width: 740px) {
    padding-bottom: 1.5rem;
  }
}
</style>
